<section>

     <app-banner_section-type01 [options]="{ title: 'BECOME A MEMBER', imageHref: 'https://www.xltravel.co.za/images/XL.jpg' }"></app-banner_section-type01>

     <div>
          <div class="p-4 rounded-3xl">
               <div class="flex flex-col">
                    @if (view.site && view.site.profile && view.site.profile.heading) {
                    @switch (view.site.profile.heading.position) {
                    @case (1) {
                    <app-heading_section-type01
                         [options]="{heading:view.page?.content.name,title:'Discover Your Perfect Getaway with XL Travel',image:'', description:'',swooshAlign: {'margin':''} }"></app-heading_section-type01>
                    }
                    @case (2) {
                    <app-heading_section-type01
                         [options]="{heading:'',title:'Discover Your Perfect Getaway with XL Travel',image:'', description:''}"></app-heading_section-type01>
                    }
                    }
                    }
               </div>
          </div>
     </div>

     <div class="p-8">
          <div class="font-medium text-3xl">Become a Member of XL Travel and Elevate Your Journey!</div>
          <p class="text-gray-600 mt-6 text-lg">Welcome to XL Travel, your key to unparalleled travel opportunities and
               exclusive benefits. As a member of our consortium, you’ll gain access to premium services that cater to
               your unique travel needs. XL Travel provides the tools, insights, and partnerships to ensure your journeys are exceptional. Join us and discover a world of
               exclusive offers, global connections, and dedicated support designed to enhance every step of your travel
               experience.
          </p>
          <form [formGroup]="form" (ngSubmit)="submitForm()">
               <div class="mt-8 grid lg:grid-cols-2 gap-4">
                    <div class="">
                         <label for="title" class="text-sm text-gray-700 block mb-1 font-medium">Title</label>
                         <select name="title" id="title" formControlName="title"
                              class="bg-white border border-gray-200 rounded py-1 px-3 block focus:ring-primary-500 focus:border-primary-500 text-gray-700 w-full">
                              <option value="">Please Select</option>
                              <option value="Mr">Mr</option>
                              <option value="Mrs">Mrs</option>
                              <option value="Miss">Miss</option>
                              <option value="Ms">Ms</option>
                              <option value="Dr">Dr</option>
                              <option value="Prof">Prof</option>
                         </select>
                    </div>
                    <div class="">
                         <label for="name" class="text-sm text-gray-700 block mb-1 font-medium">Name</label>
                         <input type="text" name="name" id="name" formControlName="name"
                              class="bg-white border border-gray-200 rounded py-1 px-3 block focus:ring-primary-500 focus:border-primary-500 text-gray-700 w-full"
                              placeholder="Enter your name" />
                    </div>

                    <div>
                         <label for="surname" class="text-sm text-gray-700 block mb-1 font-medium">Surname</label>
                         <input type="text" name="surname" id="surname" formControlName="surname"
                              class="bg-white border border-gray-200 rounded py-1 px-3 block focus:ring-primary-500 focus:border-primary-500 text-gray-700 w-full"
                              placeholder="Enter your surname" />
                    </div>
                    <div>
                         <label for="email" class="text-sm text-gray-700 block mb-1 font-medium">Email Address</label>
                         <input type="text" name="email" id="email" formControlName="email"
                              class="bg-white border border-gray-200 rounded py-1 px-3 block focus:ring-primary-500 focus:border-primary-500 text-gray-700 w-full"
                              placeholder="yourmail@provider.co.za" />
                    </div>
                    <div>
                         <label for="phone" class="text-sm text-gray-700 block mb-1 font-medium">Phone Number</label>
                         <input type="number" name="phone" id="phone" formControlName="phone"
                              class="bg-white border border-gray-200 rounded py-1 px-3 block focus:ring-primary-500 focus:border-primary-500 text-gray-700 w-full"
                              placeholder="071 123 4567" />
                    </div>
                    <div>
                         <label for="city" class="text-sm text-gray-700 block mb-1 font-medium">Your City</label>
                         <input type="text" name="city" id="city" formControlName="city"
                              class="bg-white border border-gray-200 rounded py-1 px-3 block focus:ring-primary-500 focus:border-primary-500 text-gray-700 w-full"
                              placeholder="Enter your City" />
                    </div>
               </div>
               <div class="flex justify-center space-x-4 mt-8">
                    <button type="submit"
                         class="py-2 px-4 bg-primary-500 text-white rounded hover:bg-accent-600 duration-500 active:bg-accent-700 disabled:opacity-50"  >Submit
                    </button>

               </div>
          </form>
     </div>
</section>